import {
  UrlTargetEnumTarget,
  type SubmitSettings,
} from '@wix/ambassador-forms-v4-form/types';
import { type ValidationError } from '@wix/form-validator';
import {
  type RichContent,
  type Node_Type,
  type TextStyle_TextAlignment,
} from '@wix/ricos';

export const redirectToExternalUrl = (
  redirectOptions?: SubmitSettings['redirectOptions'],
) => {
  const urlWithoutProtocol = redirectOptions?.redirectUrl?.replace(
    /^https?:\/\//,
    '',
  );
  const updatedExternalUrl = `https://${urlWithoutProtocol}`;
  window.open(
    updatedExternalUrl,
    redirectOptions?.target === UrlTargetEnumTarget.SELF ? '_self' : '_blank',
  );
};

export const isValidUrl = (url: string) => {
  const urlPattern = new RegExp(
    /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/g,
  );
  return urlPattern.test(url);
};

export const getErrorCode = (error: any): string => {
  return (
    error?.response?.data?.details?.applicationError?.code ||
    (error?.code && String(error?.code)) ||
    error?.response?.data?.details?.validationError?.fieldViolations?.[0]?.data
      ?.errors?.[0]?.errorType ||
    'UNKNOWN'
  );
};

export const getErrorList = (error: any): ValidationError[] => {
  return error?.response?.data?.details?.validationError?.fieldViolations?.[0]
    .data.errors;
};

export const getFormCustomErrorMessage = (errors: ValidationError[]) =>
  errors?.filter(
    (error) => error.useCustomErrorMessage && !error.errorPath,
  )?.[0]?.errorMessage;

export const getFieldCustomErrorMessages = (errors: ValidationError[]) =>
  errors?.filter((error) => error.useCustomErrorMessage && error.errorPath);

export const getCheckoutMessage = (text: string): RichContent => {
  return {
    nodes: [
      {
        id: 'ymnqxbmks',
        type: 'PARAGRAPH' as Node_Type,
        paragraphData: {
          textStyle: {
            textAlignment: 'CENTER' as TextStyle_TextAlignment,
          },
        },
        nodes: [
          {
            nodes: [],
            id: '',
            type: 'TEXT' as Node_Type,
            textData: {
              text,
              decorations: [],
            },
          },
        ],
      },
    ],
    metadata: {
      version: 1,
      id: 'af4951a2-dd8f-44ec-b2dc-cb4c09f65ee9',
    },
  };
};
